import Vue from 'vue'
import Router from 'vue-router'
import {
  mutipleMarketManage,
  marketManage,
  managementRightsManage,
  ExternalMarketManager,
} from './market'
import flowCenter from './flow-center'
import { ExternalStoreManager, storeManager } from './store'
import {
  userManage,
  departmentManage,
  roleManage,
  linerManage,
  dictionaryManage,
  permissionManage,
  baseConfigManage,
  businessManagement,
} from './base'

Vue.use(Router)
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => err)
}

const routes = [
  { path: '/', redirect: '/main/home' },
  { path: '/login', component: () => import('@/page/login') },
  {
    path: '/main',
    component: () => import('@/components/layout/layout'),
    children: [
      {
        path: 'mdmConfig',
        name: 'mdmConfig',
        component: () => import('@/page/main/mdmConfig/index.vue'),
        meta: { router: [{ title: '首页', path: '/main/home' }, { title: 'MDM 推送配置', path: '' }] },
      },
      {
        path: '/',
        redirect: 'home',
      },
      {
        //辅助页面
        path: 'assist',
        name: 'assist',
        component: () => import('@/page/assist'),
      },
      {
        name: 'home',
        path: 'home',
        component: () => import('@/page/main/home'),
        meta: {
          white: true,
          router: [
            { title: '首页', path: '/' },
            { title: '欢迎使用欧派营销系统用户平台', path: '' },
          ],
        },
      },
      {
        name: 'errorView',
        path: 'errorView',
        component: () => import('@/page/errorView'),
        meta: {
          white: true,
          router: [
            { title: '首页', path: '' },
            { title: '欢迎使用欧派营销系统用户平台', path: '' },
          ],
        },
      },
      //用户相关
      ...userManage,
      //角色相关
      ...roleManage,
      //权限管理相关
      ...permissionManage,
      //部门相关
      ...departmentManage,
      //线别相关
      ...linerManage,
      //商场管理
      ...marketManage,
      //经营权管理
      ...managementRightsManage,
      //批量商场管理
      ...mutipleMarketManage,
      //商场基础配置
      ...baseConfigManage,
      //字典管理相关
      ...dictionaryManage,
      // 大商管理相关
      ...businessManagement,
      //设计师软件
      // ...desigSoftware,
      // 工作流相关
      ...flowCenter,
      ...storeManager,
      {
        name: 'desigSoftwarePurchase',
        path: 'desigSoftwarePurchase',
        props: (Router) => {
          Router.query.isUrl = 'purchase'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '设计软件账号购买', path: '/main/desigSoftware' },
          ],
        },
      },
      {
        name: 'desigSoftwareLogin',
        path: 'desigSoftwareLogin',
        props: (Router) => {
          Router.query.isUrl = 'login'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '设计软件登陆', path: '/main/desigSoftwareLogin' },
          ],
        },
      },
      {
        name: 'desigSoftwareBinding',
        path: 'desigSoftware/account_binding',
        props: (Router) => {
          Router.query.isUrl = 'binding'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '绑定效验解绑', path: '/main/desigSoftware/account_binding' },
          ],
        },
      },
      {
        name: 'desigSoftwareOrderAudit',
        path: 'desigSoftware/orderAudit',
        props: (Router) => {
          Router.query.isUrl = 'audit'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '设计软件账号审核', path: '/main/desigSoftware/orderAudit' },
          ],
        },
      },
      {
        name: 'desigSoftwareOrderExternal',
        path: 'desigSoftware/orderExternal',
        props: (Router) => {
          Router.query.isUrl = 'external'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '渠道订单', path: '/main/desigSoftware/orderExternal' },
          ],
        },
      },
      {
        name: 'desigSoftwareIndexGroup',
        path: 'desigSoftware/indexGroup',
        props: (Router) => {
          Router.query.isUrl = 'external'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '集团内部账号开通', path: '/main/desigSoftware/indexGroup' },
          ],
        },
      },
      {
        name: 'desigSoftwareOrderAuditGroup',
        path: 'desigSoftware/orderAuditGroup',
        props: (Router) => {
          Router.query.isUrl = 'external'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '集团内部账号开通审核', path: '/main/desigSoftware/orderAuditGroup' },
          ],
        },
      },
      {
        name: 'desigSoftwareCostManagement',
        path: 'desigSoftware/costManagement',
        props: (Router) => {
          Router.query.isUrl = 'external'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '设计账号费用管理', path: '/main/desigSoftware/costManagement' },
          ],
        },
      },
      {
        name: 'desigSoftwareCostDetails',
        path: 'desigSoftware/costDetails',
        props: (Router) => {
          Router.query.isUrl = 'external'
        },
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '费用清单明细查询', path: '/main/desigSoftware/costDetails' },
          ],
        },
      },
      {
        name: 'flyerMappingRelation',
        path: 'flyerMappingRelation',
        component: () => import('@/page/main/desigSoftware/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '传单功能配置', path: '/main/desigSoftware/orderAudit' },
          ],
        },
      },

      {
        name: 'position',
        path: 'position',
        component: () => import('@/page/main/position'),
        // component: () => import('@/page/main/position'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '职位管理', path: '' },
          ],
        },
      },
      {
        name: 'positionAuth',
        path: 'positionAuth',
        component: () => import('@/page/main/positionAuth/index'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '集团岗位权限管理', path: '' },
          ],
        },
      },
      //system
      {
        name: 'systemLog',
        path: 'systemLog',
        component: () => import('@/page/main/systemLog'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '系统日志', path: '' },
          ],
        },
      },
      {
        name: 'dataTieAssert',
        path: 'dataTieAssert',
        component: () => import('@/page/main/businessObj/dataTieAssert'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '数据域权限维护', path: '' },
            { title: '数据库维护', path: '' },
          ],
        },
      },
      {
        name: 'business',
        path: 'business',
        component: () => import('@/page/main/businessObj/business'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '数据域权限维护', path: '' },
            { title: '业务对象', path: '' },
          ],
        },
      },
      {
        name: 'thirdParty',
        path: 'thirdParty',
        component: () => import('@/page/main/thirdParty'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '配发服务商管理', path: '' },
          ],
        },
      },
      {
        name: 'synchrodata',
        path: 'synchrodata',
        component: () => import('@/page/main/synchrodata'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '数据同步', path: '' },
          ],
        },
      },
      {
        name: 'process',
        path: 'process',
        component: () => import('@/page/main/process'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '商场组织管理', path: '/main/process' },
          ],
        },
      },
      {
        name: 'relatedMarket',
        path: 'related-market',
        component: () => import('@/page/main/RelevanceMarket'),
        meta: {
          router: [
            { title: '首页', path: '/main/home' },
            { title: '关联商场', path: '/main/related-market' },
          ],
        },
      },
    ],
  },
  // 外部访问，无需菜单页面
  ...ExternalStoreManager, // 门店管理相关
  ...ExternalMarketManager, // 商场管理相关
  // 通用页面
  { path: '/404', name: 'notFound', component: () => import('@/page/404'), meta: { white: true } }, //找不到该页面
  { path: '/302', name: 'waiting', component: () => import('@/page/302'), meta: { white: true } }, //302重定向维护界面
  { path: '/test', name: 'test', component: () => import('@/page/test'), meta: { white: true } }, //测试
  { path: '*', name: '404', redirect: '/404', meta: { white: true } },
]

const router = new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    // debugger
    return {
      x: 0,
      y: 0,
    }
  },
  routes,
})
export default router
